import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import BottomNav from './components/BottomNav';
import HeaderIcons from './components/HeaderIcons';
import Welcome from './pages/Welcome';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import AddClient from './pages/AddClient';
import ClientProfile from './pages/ClientProfile';
import EditClient from './pages/EditClient';
import LogSession from './pages/LogSession';
import Schedule from './pages/Schedule';
import Invoices from './pages/Invoices';
import Exercises from './pages/Exercises';
import Programs from './pages/Programs';
import ProgramBuilder from './pages/ProgramBuilder';
import Nutrition from './pages/Nutrition';
import NutritionPlanBuilder from './pages/NutritionPlanBuilder';
import Metrics from './pages/Metrics';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Support from './pages/Support';
import ClientLogin from './pages/ClientLogin';
import ClientRegister from './pages/ClientRegister';
import ClientPortal from './pages/ClientPortal';
import SocialFeed from './pages/SocialFeed';
import Profile from './pages/Profile';
import AccountSettings from './pages/AccountSettings';
import InviteTeamMembers from './pages/InviteTeamMembers';
import ManageTeam from './pages/ManageTeam';
import Messages from './pages/Messages';
import BrandingSettings from './pages/BrandingSettings';
import LandingPageSettings from './pages/LandingPageSettings';
import DevTools from './pages/DevTools';

function PrivateRoute({ children }) {
  const { trainer, loading } = useAuth();
  if (loading) {
    return (
      <div className="loading-spinner" style={{ minHeight: '100vh' }}>
        <span className="spinner" />
        <span>Loading...</span>
      </div>
    );
  }
  if (trainer) return children;
  const seen = localStorage.getItem('ptm_welcome_seen');
  return <Navigate to={seen ? '/login' : '/welcome'} replace />;
}

function DevRoute({ children }) {
  const { trainer, loading } = useAuth();
  if (loading) return null;
  if (!trainer) return <Navigate to="/login" replace />;
  if (trainer.role !== 'dev') return <Navigate to="/" replace />;
  return children;
}

function RootRedirect() {
  const { trainer, loading } = useAuth();
  if (loading) return null;
  if (trainer) return <Navigate to="/" replace />;
  const seen = localStorage.getItem('ptm_welcome_seen');
  return <Navigate to={seen ? '/login' : '/welcome'} replace />;
}

const HIDE_NAV_PATHS = ['/session'];

function AppLayout() {
  const { trainer } = useAuth();
  const location = useLocation();



  if (!trainer) return null;

  const hideNav = HIDE_NAV_PATHS.some(p => location.pathname.includes(p));

  return (
    <>
      {!hideNav && <BottomNav />}
      <main className={hideNav ? '' : 'main-content'}>
        <HeaderIcons />
        <Routes>
          <Route path="/"                     element={<Dashboard />} />
          <Route path="/clients"              element={<Clients />} />
          <Route path="/clients/new"          element={<AddClient />} />
          <Route path="/clients/:id"          element={<ClientProfile />} />
          <Route path="/clients/:id/edit"     element={<EditClient />} />
          <Route path="/clients/:id/session"  element={<LogSession />} />
          <Route path="/schedule"             element={<Schedule />} />
          <Route path="/invoices"             element={<Invoices />} />
          <Route path="/exercises"            element={<Exercises />} />
          <Route path="/programs"             element={<Programs />} />
          <Route path="/programs/:id"         element={<ProgramBuilder />} />
          <Route path="/nutrition"             element={<Nutrition />} />
          <Route path="/nutrition/:id"          element={<NutritionPlanBuilder />} />
          <Route path="/metrics"               element={<Metrics />} />
          <Route path="/settings/account"     element={<AccountSettings />} />
          <Route path="/settings/invite"      element={<InviteTeamMembers />} />
          <Route path="/settings/team"        element={<ManageTeam />} />
          <Route path="/settings/branding"    element={<BrandingSettings />} />
          <Route path="/settings/landing-page" element={<LandingPageSettings />} />
          <Route path="/messages"             element={<Messages />} />
          <Route path="/dev/tools"            element={<DevRoute><DevTools /></DevRoute>} />
          <Route path="*"                     element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/welcome"              element={<Welcome />} />
          <Route path="/login"                element={<Login />} />
          <Route path="/register"             element={<Register />} />
          <Route path="/privacy-policy"        element={<PrivacyPolicy />} />
          <Route path="/privacy"               element={<PrivacyPolicy />} />
          <Route path="/terms"                 element={<Terms />} />
          <Route path="/support"               element={<Support />} />
          <Route path="/client-login"         element={<ClientLogin />} />
          <Route path="/client-register"      element={<ClientRegister />} />
          <Route path="/portal"               element={<ClientPortal />} />
          <Route path="/feed"                 element={<SocialFeed />} />
          <Route path="/profile"              element={<Profile />} />
          <Route path="/profile/:profileId"   element={<Profile />} />
          <Route path="/landing"              element={<RootRedirect />} />
          <Route path="/*"                    element={<PrivateRoute><AppLayout /></PrivateRoute>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
